import { Injectable } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { successOrUndefined } from '../utils/successOrUndefined';
import { DeleteDialogComponent } from './delete-dialog/delete-dialog.component';
import { MessageDialogComponent } from './message-dialog/message-dialog.component';
import { SelectimageComponent } from './selectimage/selectimage.component';
import { SignaturedialogComponent } from './signaturedialog/signaturedialog.component';

@Injectable({
  providedIn: 'root'
})
export class DialogService {

  constructor(public modalService: NgbModal) { }

  async dismissAllDialogs() {
    this.modalService.dismissAll();
  }

  async openMessageDialog(title: string, message: string = ''): Promise<any> {
    const dialog = this.modalService.open(MessageDialogComponent, { backdrop: "static" });
    dialog.componentInstance.title = title;
    dialog.componentInstance.message = message;
    return await successOrUndefined(dialog.result);
  }

  async openDeleteDialog(text, id, callback) {
    const dialog = this.modalService.open(DeleteDialogComponent, { backdrop: "static" });
    dialog.componentInstance.text = text;
    dialog.componentInstance.id = id;
    dialog.componentInstance.callback = callback;
    return await successOrUndefined(dialog.result);
  }

  async openTextInputDialog(text, callback) {
    const dialog = this.modalService.open(DeleteDialogComponent, { backdrop: "static" });
    dialog.componentInstance.text = text;
    dialog.componentInstance.callback = callback;
    return await successOrUndefined(dialog.result);
  }

  async openSelectImageDialog(doc, page, clientMode) {
    const dialog = this.modalService.open(SelectimageComponent, { backdrop: "static" });
    dialog.componentInstance.doc = doc;
    dialog.componentInstance.page = page;
    dialog.componentInstance.clientMode = clientMode;
    return await successOrUndefined(dialog.result);
  }

  async openSelectSignatureDialog(items, doc, page, onAddSignatureById, onAddPenSignature, onAddImageSignature, onAddTextSignature) {
    const dialog = this.modalService.open(SignaturedialogComponent);
    dialog.componentInstance.items = items;
    dialog.componentInstance.doc = doc;
    dialog.componentInstance.page = page;
    dialog.componentInstance.onAddSignatureById = onAddSignatureById;
    dialog.componentInstance.onAddPenSignature = onAddPenSignature;
    dialog.componentInstance.onAddImageSignature = onAddImageSignature;
    dialog.componentInstance.onAddTextSignature = onAddTextSignature;
    return await successOrUndefined(dialog.result);
  }
}
